import SearchFilterInput from './SearchFilterInput'

export default SearchFilterInput



// WEBPACK FOOTER //
// ./src/components/SearchFilterInput/index.js